import { render, staticRenderFns } from "./PainterSuperTalk.vue?vue&type=template&id=ebbd5cde&scoped=true"
import script from "./PainterSuperTalk.vue?vue&type=script&lang=js"
export * from "./PainterSuperTalk.vue?vue&type=script&lang=js"
import style0 from "./PainterSuperTalk.vue?vue&type=style&index=0&id=ebbd5cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebbd5cde",
  null
  
)

export default component.exports